import React from 'react';

const RadioButton = props => {
  const { label, id, value, onChange, checked, disabled = false } = props;
  return (
    <div className="radio-input">
      <input
        type="radio"
        id={id}
        checked={checked}
        onChange={e => {
          onChange(value);
        }}
        disabled={disabled}
        className="radio-btn"
        value={value}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

export default RadioButton;
